import { Link } from 'react-router-dom';

export default function CategoryIcons() {
  const categories = [
    { 
      icon: 'ri-capsule-line', 
      name: 'Vitamins', 
      color: 'bg-amber-100 text-amber-600',
      link: '/vitamins'
    },
    { 
      icon: 'ri-flask-line', 
      name: 'Minerals', 
      color: 'bg-orange-100 text-orange-600',
      link: '/minerals'
    },
    { 
      icon: 'ri-heart-pulse-line', 
      name: 'Heart Health', 
      color: 'bg-red-100 text-red-600',
      link: '/heart-health'
    },
    { 
      icon: 'ri-brain-line', 
      name: 'Brain Support', 
      color: 'bg-indigo-100 text-indigo-600',
      link: '/brain-support'
    },
    { 
      icon: 'ri-shield-check-line', 
      name: 'Immunity', 
      color: 'bg-emerald-100 text-emerald-600',
      link: '/immunity'
    },
    { 
      icon: 'ri-muscle-line', 
      name: 'Sports Nutrition', 
      color: 'bg-teal-100 text-teal-600',
      link: '/sports-nutrition'
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-white to-emerald-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Supplement Categories
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-6 gap-6">
          {categories.map((category, index) => (
            <Link
              key={index}
              to={category.link}
              className="flex flex-col items-center group cursor-pointer"
            >
              <div className={`w-20 h-20 ${category.color} rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                <i className={`${category.icon} text-3xl`}></i>
              </div>
              <span className="text-sm font-medium text-gray-700 text-center group-hover:text-gray-900 transition-colors">
                {category.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
